import React, { ReactElement, useEffect, useState } from 'react';
import cs from 'classnames';
import Circle from '../../../lib/icons/icon_assets/circle.svg';
import Checkmark from '../../../lib/icons/icon_assets/checkmark.svg';
import FontFamily from '../fontFamily';
import { RadioboxGroupContext } from './context';

import './index.scss';

interface RaidoProps {
  /** 类型 */
  type: 'normal' | 'special';
  /** 对齐方式 */
  align: 'left' | 'right';
  /** 内容是否定高 */
  certainHeight: boolean;
  /** 是否选中 */
  checked: boolean;
  /** 禁用 */
  disabled?: boolean;
  /** 热区范围 - 全域/icon区域 */
  hotArea?: 'all' | 'icon';
  /** 状态改变回调 */
  onChange?: (checkStatus: boolean) => void;
  children?: ReactElement;
  value?: string;
  className?: string;
}
// eslint-disable-next-line max-lines-per-function
export const Radiobox = (props: RaidoProps): ReactElement => {
  const prefixCls = 'design-system-radiobox';

  const {
    type = 'normal',
    align = 'left',
    certainHeight = true,
    checked = false,
    disabled = false,
    hotArea = 'all',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = (): void => {},
    children,
    value,
    className,
  } = props;

  const radioboxContext = React.useContext(RadioboxGroupContext);
  const isSelect =
    checked || Boolean(value && radioboxContext?.defaultValue && radioboxContext?.defaultValue === value);
  const isDisabled = disabled || radioboxContext?.disabled;

  const [select, setSelect] = useState(isSelect);

  useEffect(() => {
    setSelect(Boolean(value && radioboxContext?.defaultValue === value));
  }, [radioboxContext?.defaultValue]);

  const handleRadioboxClick = (event: any): void => {
    if (isDisabled) {
      return;
    }
    const _checked = event.target.value;
    setSelect(_checked);
    onChange(_checked);
    radioboxContext?.onChange && radioboxContext.onChange({ value, select: _checked });
  };

  const renderIcon = (): ReactElement | null => {
    if (type === 'normal') {
      if (select) {
        return (
          <div className={`${prefixCls}-normal-icon-selected-container`}>
            <div className={`${prefixCls}-normal-icon-selected`}>
              <div className={`${prefixCls}-normal-icon-selected-circle`} />
            </div>
          </div>
        );
      } else {
        return <Circle className={`${prefixCls}-normal-icon-unselected`} />;
      }
    } else if (type === 'special') {
      if (select) {
        return <Checkmark className={`${prefixCls}-special-icon-selected`} />;
      } else {
        return <div className={`${prefixCls}-special-icon-selected`} />;
      }
    } else {
      return null;
    }
  };

  return (
    <FontFamily>
      {hotArea === 'all' ? (
        <label
          type="radio"
          className={cs(`${prefixCls}-container`, className, {
            certainHeight,
            disabled,
            [align]: align,
          })}
        >
          {renderIcon()}
          <input
            type="radio"
            value={value}
            name={radioboxContext?.name}
            checked={select}
            onChange={(event: any): void => {
              handleRadioboxClick(event);
            }}
          />
          <div
            className={cs(`${prefixCls}-content`, {
              [align]: align,
            })}
          >
            {children}
          </div>
        </label>
      ) : (
        <div
          className={cs(`${prefixCls}-container`, className, {
            certainHeight,
            disabled,
            [align]: align,
          })}
        >
          <label className={`${prefixCls}-hotarea`}>
            <input
              type="radio"
              value={value}
              checked={select}
              name={radioboxContext?.name}
              onChange={(event: any): void => {
                handleRadioboxClick(event);
              }}
            />
            {renderIcon()}
          </label>
          <div
            className={cs(`${prefixCls}-content`, {
              [align]: align,
            })}
          >
            {children}
          </div>
        </div>
      )}
    </FontFamily>
  );
};
